module.exports = __webpack_public_path__ + "static/logo-9421b069f5a442a22389d4f7277d3ef6.png";